import { DataSnapshot, Unsubscribe } from 'firebase/database'

import { UnreadCountsEnum } from '../../domain/models/UnreadCountsEnum'
import { UnreadCountRepository } from '../../domain/repositories/UnreadCountRepository'
import { UnreadCountDatasourceAdapter } from '../datasources/UnreadCountDatasource'

export function unreadCountRepository(
  unreadCountDatasource: UnreadCountDatasourceAdapter
): UnreadCountRepository {
  return {
    getUnreadCount(params: {
      profileId: string
      countPath: UnreadCountsEnum
      onValue: (snapshot: DataSnapshot) => unknown
    }): Unsubscribe {
      return unreadCountDatasource.getUnreadCount(params)
    },

    reduceUnreadCount(params: {
      profileId: string
      countPath: UnreadCountsEnum
      reduceBy?: number
    }): Promise<void> {
      return unreadCountDatasource.reduceUnreadCount(params)
    }
  }
}
